export default {
  token: '',
};



// WEBPACK FOOTER //
// ./FrontEnd/modulos/central-mensagens/sessao-avisos.js